import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SIDEBAR_COLORS } from '@/common/presentation/constants/colors';

export const SidebarContainer = styled('div')(({ theme }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    overflow: 'hidden',
    padding: '0',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  '& .MuiDrawer-root': {
    padding: '0',
    height: '100%'
  },
  '.MuiBox-root': {
    height: '100%'
  }
}));
export const SidebarDoubleArrowToggleButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: SIDEBAR_COLORS.BACKGROUND,
  width: 32,
  height: 32,
  zIndex: 1100,
  borderRadius: 4,
  border: `1px solid ${theme.palette.common.white}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  right: -16,
  top: 85,
  '&:hover': {
    backgroundColor: SIDEBAR_COLORS.TOGGLE_HOVER
  }
}));

export const SidebarLogo = styled('div')({
  display: 'flex',
  justifyContent: 'center'
});
